import { Alert, AppLayout, Button, Container, Header, SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { navigateWithEmbedParams } from 'src/utils/navigation-utils';

export const PageNotFound = () => {
  const [visible, setVisible] = React.useState(true);
  const navigate = useNavigate();

  const goToHomePage = () => {
    navigateWithEmbedParams(navigate, '/');
  };

  return (
    <>
      <AppLayout
        headerSelector="#h"
        navigationHide={true}
        content={
          <Container disableContentPaddings>
            <Alert
              visible={visible}
              dismissAriaLabel="Close alert"
              header={
                <Header
                  actions={
                    <SpaceBetween size="m" direction="horizontal">
                      <Button onClick={goToHomePage}>Go to Home Page</Button>
                    </SpaceBetween>
                  }
                ></Header>
              }
            >
              Page Not Found
            </Alert>
          </Container>
        }
      ></AppLayout>
    </>
  );
};
